import tw from 'twin.macro';
import styled from 'styled-components';

const Heading1 = styled.h1(() => [tw`text-5xl md:text-6xl mt-8 mb-6 font-semibold`]);

export default Heading1;
